export const AVAILABLE_ROUTES_LOCALES = ['en', 'fi', 'de', 'uk', 'lv', 'lt', 'et', 'ru']
